var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import style from './solution-box.scss';
import { SolutionTopSection } from './solution-top-section';
import { SolutionDetails } from './solution-details';
import { SolutionBottomAction } from './solution-bottom-action-bar';
import { sendSolutionImpressionBi, sendOpenSolutionPageBi, sendAddClick, sendOpenClick, } from '../../../../bi/events';
import { getAppBadgeTheme, getAppBadgeTitle, getAppBadgeTooltipContent, } from '../../../common';
import { VisibilityDetector } from '../../../../utils/visibility-detector';
import { getClientImageURL } from '../../../common/getClientImageURL';
import { Box } from '@wix/design-system';
import { withExperiments } from '../../../../component-decorators/with-experiments';
let SolutionBox = class SolutionBox extends React.Component {
    componentDidMount() {
        if (this.props.onBoxRender) {
            this.props.onBoxRender();
        }
    }
    constructor(props) {
        super(props);
        this.getLinkProps = () => {
            const { to, as } = this.props;
            return {
                to,
                as,
            };
        };
        this.onImpression = () => {
            if (!this.state.isImpression) {
                sendSolutionImpressionBi(this.props.solutionBiData);
                this.setState({ isImpression: true });
            }
        };
        this.state = { isImpression: false };
    }
    render() {
        const { solution, solutionBiData, onButtonClick, onBoxClick, isInstalled, showPremiumLabel, as, isCompany, experiments, isBundleAppInstalled, isBundleAppNotInstalled, isAppSetupIncomplete, savedPrice, isVoucherApp, hideCTA, hideTagsBadge, } = this.props;
        const { icon, teaser, numberOfReviews, reviewStars, name, company, pricing, Tags, } = solution;
        let areReviews = true;
        if (experiments &&
            experiments.enabled('specs.marketplace.solutionBox.removeReviewRating')) {
            areReviews = false;
        }
        const badgeTitle = getAppBadgeTitle(isBundleAppInstalled, isBundleAppNotInstalled, Tags, experiments, hideTagsBadge, solution?.id);
        return (React.createElement(VisibilityDetector, { onVisible: this.onImpression },
            React.createElement(Box, { className: style.solutionBox, dataHook: "solution-box", height: isCompany && areReviews ? '291px' : isCompany ? '267px' : '276px', marginTop: "15px", marginBottom: "15px" },
                React.createElement("div", { "data-appid": solution.id, onClick: () => {
                        sendOpenSolutionPageBi(solutionBiData);
                        onBoxClick(solution);
                    }, className: this.props.layout && this.props.layout !== 'marketplace'
                        ? style.solutionBoxWrapperIntegrationsLayout
                        : style.solutionBoxWrapperMarketplaceLayout },
                    React.createElement(ConditionalLinkRenderer, { ...this.getLinkProps() },
                        React.createElement(SolutionTopSection, { alt: `${name} logo`, solutionIcon: getClientImageURL(icon), badgeTitle: badgeTitle, badgeTheme: getAppBadgeTheme(badgeTitle), showTooltip: isBundleAppInstalled || isBundleAppNotInstalled, tooltipContent: getAppBadgeTooltipContent(isBundleAppInstalled, isBundleAppNotInstalled, isVoucherApp), solutionName: name }),
                        React.createElement(SolutionDetails, { teaser: teaser, name: name, isCompany: isCompany, company: company.name, reviews: { numberOfReviews, reviewStars }, layout: this.props.layout })),
                    React.createElement(Box, { height: isCompany ? '24px' : '25px' }),
                    React.createElement(SolutionBottomAction, { isInstalled: isInstalled, showPremiumLabel: showPremiumLabel, pricing: pricing, reviews: areReviews ? { numberOfReviews, reviewStars } : null, onButtonClick: () => {
                            isInstalled
                                ? sendOpenClick(solutionBiData)
                                : sendAddClick(solutionBiData);
                            onButtonClick(solution);
                        }, isBundleAppInstalled: isBundleAppInstalled, isBundleAppNotInstalled: isBundleAppNotInstalled, isAppSetupIncomplete: isAppSetupIncomplete, savedPrice: savedPrice, isVoucherApp: isVoucherApp, hideCTA: hideCTA })))));
    }
};
SolutionBox = __decorate([
    withExperiments
], SolutionBox);
export { SolutionBox };
const FakeLink = ({ to, className, children }) => {
    return (React.createElement("a", { href: to, className: className, onClick: (e) => e.preventDefault() }, children));
};
export const ConditionalLinkRenderer = ({ as, to, className, children, }) => {
    if (as === 'link') {
        if (to === undefined) {
            console.warn("trying to render component as 'link' without passing 'to' prop");
        }
        return (React.createElement(FakeLink, { to: to, className: `${style.boxLink} ${className}` }, children));
    }
    return children;
};
//# sourceMappingURL=index.js.map